import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  Avatar,
  Skeleton,
} from "@mui/material";
// import freeVoteIcon from "../../../assets/customerAssets/icons/voteIcon.svg";
// import freeVoteIconV from "../../../assets/customerAssets/freeVotesIcon.svg";
// import freeVoteIcon from "../../../assets/customerAssets/icons/voteIcon.svg";
// import freeVoteIconV from "../../../assets/customerAssets/freeVotesIcon.svg";
import freeVoteIconV from "../../../assets/customerAssets/icons/crownVoteIconRed.svg";
import freeVoteIcon from "../../../assets/customerAssets/icons/crownVoteIcon.svg";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addVote , addGuestVote } from "../../../api/addVote";
import { getGoalVotes } from "../../../api/getGoalVote";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import GuestUserRistModal from "../../Modals/user/guestUserModalRist/Modal";
import { handleGuestVoteFailure } from "../../../utils/guestVote";

const VoteComponent = ({ vote, id, count, setCount }) => {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guestModal, setGuestModal] = useState(false);
  // const [gcount, setCount] = useState(count);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const loggedUser = useSelector((state)=>state.loggedUser.user)
  const handleClicked = async () => {
    try {
      // if (user.data.is_skip) {
      //   navigate("/register");
      //   return;
      // }
      // setLoading(true);

      setLoading(true);
      if (loggedUser.device_id) {
        console.log("initiate vote api for guest");
        const data = await addGuestVote(loggedUser.id, id, token);

        if (data.success) {
          setCount((gcount) => gcount + 1);
          // dispatch({ type: "DCREMENT_VOTE" });

          // setLeaderboard((ldata) => {
          //   const newLeaderboard = ldata.map((ldata) =>
          //     ldata.id == id
          //       ? { ...ldata, isVoted: true, voteCount: ldata.voteCount + 1 }
          //       : ldata,
          //   );

          //   const sortedLeaderboard = newLeaderboard
          //     .sort((a, b) => (a.voteCount > b.voteCount ? -1 : 1))
          //     .map((data, i) => ({ ...data, rank: i + 1 }));

          //   return sortedLeaderboard;
          // });

          setLoading(false);
          toast.success(data.message);
        } else {
          const handled = handleGuestVoteFailure(data, {
            onLimit: () => setGuestModal(true),
            onDisabled: (msg) => toast.error(msg || data.message),
          });
          if (!handled) {
            toast.error(data.message);
          }
        }
        // navigate("/register");
        return;
      }
      if (token && user.data.id) {
        const data = await addVote(user.data.id, id, token);
        if (data.success) {
          setCount((v) => v + 1);
          dispatch({ type: "DCREMENT_VOTE" });

          setLoading(false);
          setClicked(true);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
      }
    } catch (error) {
      if (error.guestVotingDisabled) {
        toast.error(error.message);
      } else if (error.requiresRegistration) {
        setGuestModal(true);
      }
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <GuestUserRistModal open={guestModal} setOpen={setGuestModal} />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Button className="icon-div" onClick={handleClicked}>
          {loading ? (
            <Skeleton animation="wave" height={27} width={27} />
          ) : (
            <img
              src={vote || clicked ? freeVoteIconV : freeVoteIcon}
              className="iconImg"
            />
          )}
        </Button>

        <Typography component="span" sx={{ color: "white" }}>
          {count}
        </Typography>
      </Box>
    </>
  );
};

export default VoteComponent;
